import moment from 'moment';

/**
 * @param {Pick<Partial<spot>, 'mission_enabled' | 'mission_start_immediately' | 'mission_start_datetime' | 'mission_end_datetime'>} spot
 * @param {Pick<Partial<map>, 'alias_map_event_start_datetime' | 'alias_map_event_end_datetime'>} map
 */
export const isDuringMission = (spot, map) => {
  const now = moment().utc().format('YYYY-MM-DD HH-mm-ss');

  if (!spot.mission_enabled) {
    return { result: false, error: '該当ミッションがありません。' };
  }

  const mission_start_datetime =
    (spot.mission_start_datetime > map.alias_map_event_start_datetime) ? spot.mission_start_datetime : map.alias_map_event_start_datetime;
  const mission_end_datetime =
    (spot.mission_end_datetime > map.alias_map_event_end_datetime) ? map.alias_map_event_end_datetime : spot.mission_end_datetime;
  // check start
  if (
    !spot.mission_start_immediately &&
    (!mission_start_datetime || now < mission_start_datetime)
  ) {
    return { result: false, error: 'ミッションが開始されていません。' };
  }

  // check end
  if (mission_end_datetime && mission_end_datetime < now) {
    return { result: false, error: 'ミッションは終了しました。' };
  }

  // nothing is set
  if (
    !spot.mission_start_immediately &&
    !mission_start_datetime &&
    !mission_end_datetime
  ) {
    return { result: false, error: '該当ミッションがありません。' };
  }

  return { result: true };
};
